export default "__VITE_ASSET__CCTBf7xl__"